import React, { useState, useEffect } from "react";
import { render } from "react-dom";
import Home from "./Pages/HomePage";
import {
  BrowserRouter as Router,
  HashRouter,
  Route,
  Link,
  Routes,
  Navigate,
} from "react-router-dom";
import MultiChartsView from "./Pages/MultiChartsPage";
import Screener from "./Pages/ScreenerPage";
import NavigationBar from "./Components/NavigationBar";
import LargeChartPage from "./Pages/LargeChartPage";
import TablePage from "./Pages/TablePage";
import SignalPage from "./Pages/SignalPage";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import PairChartsPage from "./Pages/PairChartsPage";
import SectorChartsPage from "./Pages/SectorChartsPage";
import HeatmapsPage from "./Pages/HeatmapsPage";
import HeatmapsChartPage from "./Pages/HeatmapsChartPage";
import PortfolioPage from "./Pages/PortfolioPage";
import BacktestPage from "./Pages/BacktestPage";
import DataSyncPage from "./Pages/DataSyncPage";
import SignalsPage from "./Pages/SignalsPage";
import LoginPage from "./Pages/LoginPage";
import PaperTradingPage from "./Pages/PaperTradingPage";

const API_BASE = process.env.REACT_APP_API_URL !== undefined ? process.env.REACT_APP_API_URL : "http://localhost:49152";

const App = () => {
  const [token, setToken] = useState(localStorage.getItem("auth_token"));

  const handleLogin = (newToken) => {
    setToken(newToken);
    window.location.hash = "#/";
  };

  const handleLogout = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_user");
    setToken(null);
  };

  useEffect(() => {
    if (token) {
      fetch(`${API_BASE}/auth/check`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((r) => {
          if (!r.ok) handleLogout();
        })
        .catch(() => handleLogout());
    }
  }, []);

  const theme = createTheme({
    palette: {
      mode: "light",
      primary: { main: "#1976d2" },
      secondary: { main: "#9c27b0" },
      background: { default: "#f5f7fa", paper: "#ffffff" },
      success: { main: "#2e7d32" },
      error: { main: "#d32f2f" },
    },
    typography: {
      fontFamily: "'Inter', 'Roboto', 'Helvetica', sans-serif",
      h4: { fontWeight: 700 },
      h6: { fontWeight: 600 },
    },
    shape: { borderRadius: 10 },
    components: {
      MuiCard: {
        styleOverrides: {
          root: { boxShadow: "0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06)" },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: { boxShadow: "0 1px 3px rgba(0,0,0,0.08)" },
        },
      },
    },
  });

  if (!token) {
    return (
      <ThemeProvider theme={theme}>
        <LoginPage onLogin={handleLogin} />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <div style={{ display: "flex", flexDirection: "column", width: "fit-content" }}>
        <HashRouter>
          <div>
            <NavigationBar onLogout={handleLogout} />
            <Routes>
              <Route path="/multiview" element={<MultiChartsView />} />
              <Route path="/screener" element={<Screener />} />
              <Route path="/chart" element={<LargeChartPage />} />
              <Route path="/pair" element={<PairChartsPage />} />
              <Route path="/table" element={<TablePage />} />
              <Route path="/signal" element={<SignalPage />} />
              <Route path="/sector" element={<SectorChartsPage />} />
              <Route path="/heatmap" element={<HeatmapsPage />} />
              <Route path="/treemap-chart" element={<HeatmapsChartPage/>} />
              <Route path="/portfolio" element={<PortfolioPage/>} />
              <Route path="/backtest" element={<BacktestPage/>} />
              <Route path="/data-sync" element={<DataSyncPage />} />
              <Route path="/signals" element={<SignalsPage />} />
              <Route path="/paper-trading" element={<PaperTradingPage/>} />
              <Route path="/" element={<Home />} />
            </Routes>
          </div>
        </HashRouter>
      </div>
    </ThemeProvider>
  );
};

render(<App />, document.getElementById("root"));
